/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/order_source';
import '../../../model/order';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "SharedCartInfo": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "acceptFreightShipping": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "CreateInternalOrderRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "guestToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "email": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 4,
                        "rule": "required"
                      },
                      "source": {
                        "type": "squareup.solidshop.v2.common.OrderSource",
                        "id": 5,
                        "rule": "required"
                      },
                      "internal": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "internalType": {
                        "type": "squareup.solidshop.model.Order.SqInternalType",
                        "id": 7,
                        "rule": "optional",
                        "options": {
                          "default": "UNKNOWN"
                        }
                      },
                      "frontendViewable": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "userAgent": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "sharedCartInfo": {
                        "type": "squareup.solidshop.v2.service.SharedCartInfo",
                        "id": 10,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateInternalOrderResponse": {
                    "fields": {
                      "order": {
                        "type": "squareup.solidshop.model.Order",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE SharedCartInfo @ squareup/solidshop/v2/service/orders/create_internal_order.proto at 15:1
 */
export const SharedCartInfo = $root.lookupType('squareup.solidshop.v2.service.SharedCartInfo');
fixType(SharedCartInfo);
Builder.createAndAttachToType(SharedCartInfo);
/**
 * SOURCE CreateInternalOrderRequest @ squareup/solidshop/v2/service/orders/create_internal_order.proto at 23:1
 */
export const CreateInternalOrderRequest = $root.lookupType('squareup.solidshop.v2.service.CreateInternalOrderRequest');
fixType(CreateInternalOrderRequest);
Builder.createAndAttachToType(CreateInternalOrderRequest);
/**
 * SOURCE CreateInternalOrderResponse @ squareup/solidshop/v2/service/orders/create_internal_order.proto at 57:1
 */
export const CreateInternalOrderResponse = $root.lookupType('squareup.solidshop.v2.service.CreateInternalOrderResponse');
fixType(CreateInternalOrderResponse);
Builder.createAndAttachToType(CreateInternalOrderResponse);
